import React, { useLayoutEffect, useMemo } from "react";
import { Outlet } from "react-router";

import LoginBackground from "../assets/img/login_background.png";
import Login1 from "../assets/img/login_1.jpg";
import Login2 from "../assets/img/login_2.jpg";
import Login3 from "../assets/img/login_3.jpg";
import Login4 from "../assets/img/login_4.jpg";
import Login5 from "../assets/img/login_5.jpg";
import Login6 from "../assets/img/login_6.jpg";
import UlisesLogin from "../assets/img/ulises_login.png";

const AUTH_IMAGE_OPTIONS = [Login1, Login2, Login3, Login4, Login5, Login6];

const getRandomAuthImage = () =>
  AUTH_IMAGE_OPTIONS[Math.floor(Math.random() * AUTH_IMAGE_OPTIONS.length)];

const AuthLayout = () => {
  const randomAuthImage = useMemo(() => getRandomAuthImage(), []);

  useLayoutEffect(() => {
    document.body.style.background = `url('${LoginBackground}')`;
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundSize = "cover";
    return;
  }, []);

  return (
    <>
      <div className="container animated--grow-in">
        {/* <!-- Outer Row --> */}
        <div className="row justify-content-center d-flex vh-100">
          <div className="col-xl-10 col-lg-12 col-md-9 m-auto">
            <div className="card border-0 shadow-lg my-5" style={{ overflow: "hidden" }}>
              <div className="card-body p-0">
                {/* <!-- Nested Row within Card Body --> */}
                <div className="row">
                  <div
                    className="col-lg-6 d-none d-lg-block bg-auth-image"
                    style={{ backgroundImage: `url('${randomAuthImage}')` }}
                  >
                    <img src={UlisesLogin} alt="Ulises" className="bg-auth-image__mascot" />
                  </div>
                  <div className="col-lg-6">
                    <Outlet />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthLayout;